import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type RecordingCompletionFailedAction = {
	type: 'RECORDING_COMPLETION_FAILED';
	payload: ExtractedMessages;
	/** Read straight off the HTTP response — see `interviewCreationFailed.ts` for why. */
	status: number | null;
};

export default (payload: ExtractedMessages, status: number | null): RecordingCompletionFailedAction => ({
	type: 'RECORDING_COMPLETION_FAILED',
	payload,
	status,
});
